module.exports = __webpack_public_path__ + "img/Bootstrupp.a11b9f78.svg";